import AbstractChannel from './AbstractChannel'

export default class T2 extends AbstractChannel {

  name = 't2'
  title = 'T2'
  titleShort = 'T2'
  color = '#E377C2'

}
